import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';

const ContributionHistoryColumns = [
  ConstituentSearchColumn.LIFETIME_COUNT,
  ConstituentSearchColumn.LIFETIME_DONATIONS,
  ConstituentSearchColumn.LIFETIME_HOURS,
  ConstituentSearchColumn.THIS_YEAR_COUNT,
  ConstituentSearchColumn.THIS_YEAR_DONATIONS,
  ConstituentSearchColumn.THIS_YEAR_HOURS,
];

export default ContributionHistoryColumns;
